import { render, staticRenderFns } from "./ClaimCreditsBox.vue?vue&type=template&id=7c59430b"
import script from "./ClaimCreditsBox.vue?vue&type=script&lang=js"
export * from "./ClaimCreditsBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports